import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=7ecd2717&scoped=true&"
import script from "./Stage.vue?vue&type=script&lang=ts&"
export * from "./Stage.vue?vue&type=script&lang=ts&"
import style0 from "./Stage.vue?vue&type=style&index=0&id=7ecd2717&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecd2717",
  null
  
)

export default component.exports